import { render } from "./Email.vue?vue&type=template&id=cb514436"
import script from "./Email.vue?vue&type=script&lang=ts"
export * from "./Email.vue?vue&type=script&lang=ts"
script.render = render

export default script